<template>
    <div :class="`card col-12 col-md-${size} u-text-center mb-24`">
        <div class="card__content">
            <slot>
                <span v-if="number !== null" class="card__number" :class="`text-${numberTheme}`">{{ currentNumber }}</span>
                <span v-if="text !== null" class="card__text" :class="`text-${textTheme}`">{{ text }}</span>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatisticsCard',

    props: {
        number: { type: Number, default: null },
        numberTheme: { type: String, default: 'black' },
        text: { type: String, default: null },
        textTheme: { type: String, default: 'black' },
        size: { type: [String, Number], default: '12' },
    },

    data: () => ({ currentNumber: 0 }),

    mounted () {
        if (this.number) {
            this.countUp()
        }
    },

    methods: {
        countUp () {
            if (this.currentNumber === this.number) return

            const counter = setInterval(() => {
                this.currentNumber += 1
                if (this.currentNumber === this.number) {
                    clearInterval(counter)
                }
            }, 5)
        },
    },
}
</script>

<style lang="scss" scoped>
.card {
    &__content {
        padding: $spacing-unit-24;
        background: $white;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        border: 1px solid rgba($black, 0.17);
    }

    &__number {
        display: block;
        font-size: 4rem;
        line-height: 4rem;
        margin-bottom: $spacing-unit-6;
    }

    &__text {
        display: block;
        font-size: 1rem;
        line-height: 1rem;
    }
}
</style>
